module.exports = __webpack_public_path__ + "img/search_idea.b7dbd7d2.svg";